export default "__VITE_ASSET__CGdcEkeC__"